module.exports = __webpack_public_path__ + "img/pw-1.06cd9c79.jpg";